import { share } from "@/app/(store)/_utils/share";
import { Button, IconButton } from "@stone-payments/jade";
import { MessageBuilder } from "@/utils/message-builder";
import { useExperiment } from "@/contexts/analitica";
import { ExperimentsFlags } from "@/services/amplitude/experiment";

type WhatsAppIconButtonProps = {
  whatsAppNumber: string;
  name: string;
  className?: string;
  analiticaEvent?: () => void;
};

export const WhatsAppIconButton = ({
  whatsAppNumber,
  name,
  analiticaEvent,
}: WhatsAppIconButtonProps) => {
  const showCartExperiment = useExperiment(ExperimentsFlags.ShowCart);
  const buttonLabel =
    showCartExperiment.key === "on"
      ? "Conversar com a loja"
      : "Pedir pelo WhatsApp";

  const handleClick = () => {
    analiticaEvent?.();

    share.whatsapp(
      whatsAppNumber,
      MessageBuilder.buildCatalogGreeting(name, showCartExperiment)
    );
  };

  return (
    <>
      <Button
        variant="on-brand-solid"
        size="large"
        icon="brand-whatsapp"
        className="!hidden w-[235px] xl:!flex"
        onClick={handleClick}
        data-testid="whatsapp-icon-button"
      >
        {buttonLabel}
      </Button>

      <IconButton
        variant="on-brand-solid"
        size="medium"
        icon="brand-whatsapp"
        className="!flex xl:!hidden"
        onClick={handleClick}
        aria-label={buttonLabel}
        data-testid="whatsapp-icon-button-mobile"
      />
    </>
  );
};
